import React from 'react'
import { NavLink } from 'react-router-dom'
class BreadCrums extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <article className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="breadcrumb-wraper">
                                <NavLink to="/">Home</NavLink> / <span>{this.props.pageName}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        )
    }
}

export default BreadCrums